import React from 'react'
import combineClass from '@helpers/combineClass'

const CardContent = ({ children, className = '' }) => {
  return <div className={combineClass('content', className)}>{children}</div>
}

export default CardContent
